export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

export class Logger {
  private enabled: boolean;
  private level: LogLevel;

  constructor(enabled = true, level: LogLevel = LogLevel.INFO) {
    this.enabled = enabled;
    this.level = level;
  }

  private log(level: LogLevel, message: string, ...args: unknown[]): void {
    if (!this.enabled || level < this.level) {
      return;
    }

    const prefix = '[EazyNavigator]';
    const timestamp = new Date().toISOString();

    switch (level) {
      case LogLevel.DEBUG:
        console.debug(`${prefix} ${timestamp} DEBUG:`, message, ...args);
        break;
      case LogLevel.INFO:
        console.info(`${prefix} ${timestamp} INFO:`, message, ...args);
        break;
      case LogLevel.WARN:
        console.warn(`${prefix} ${timestamp} WARN:`, message, ...args);
        break;
      case LogLevel.ERROR:
        console.error(`${prefix} ${timestamp} ERROR:`, message, ...args);
        break;
    }
  }

  debug(message: string, ...args: unknown[]): void {
    this.log(LogLevel.DEBUG, message, ...args);
  }

  info(message: string, ...args: unknown[]): void {
    this.log(LogLevel.INFO, message, ...args);
  }

  warn(message: string, ...args: unknown[]): void {
    this.log(LogLevel.WARN, message, ...args);
  }

  error(message: string, ...args: unknown[]): void {
    this.log(LogLevel.ERROR, message, ...args);
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  setLevel(level: LogLevel): void {
    this.level = level;
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  getLevel(): LogLevel {
    return this.level;
  }
}
